<template>
  <div
    :class="
      $store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
        ? 'card p-1'
        : 'p-1'
    "
  >
    <div class="field">
      <label
        v-if="
          $store.state.authentification.connectUserEmail ===
            'colidee@colidee.com'
        "
        class="label"
        >{{ $t("insight.etat.colidee") }}</label
      >
      <label v-else class="label">{{ $t("insight.etat") }}</label>
      <div class="hr-grey" />
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading }"
      >
        <label class="radio">
          <div
            :style="
              isChecked_STATE
                ? 'background-color:green; padding:10px;color:white'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="1"
              name="STATE"
              v-bind:checked="isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.insight.isLoading }"
            />
            {{ $t("insight.etat_ouvert") }}
          </div>
        </label>
        <label class="radio">
          <div
            :style="
              !isChecked_STATE
                ? 'background-color:red; padding:10px;color:white'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="0"
              name="STATE"
              v-bind:checked="!isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.insight.isLoading }"
            />
            {{ $t("insight.etat_ferme") }}
          </div>
        </label>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("insight.name") }}*</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading }"
      >
        <input
          :value="insight_name"
          name="NAME"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('insight.name')"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("insight.client") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading }"
      >
        <input
          :value="insight_client"
          name="CLIENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('insight.client')"
          v-bind="{ disabled: this.$store.state.insight.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("insight.evenement") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading }"
      >
        <input
          :value="insight_evenement"
          name="EVENEMENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('insight.evenement')"
          v-bind="{ disabled: this.$store.state.insight.isLoading }"
        />
      </div>
    </div>
    
    <label class="label">{{ $t("insight.openAt") }}</label>
      <div class="control" v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading}">
        <b-datepicker
          :max-date="modelCloseAt"
          :locale="$store.state.langage.langue"
          :mobile-modal="false"
          v-model="modelOpenAt"
          :placeholder="$t('insight.openAt')"
          trap-focus
          editable
          :first-day-of-week="0"
        ></b-datepicker>
      </div>
      <label style="margin-top:10px;" class="label">{{ $t("insight.closeAt") }}</label>
      <b-datepicker
        :min-date="modelOpenAt"
        :locale="$store.state.langage.langue"
        :mobile-modal="false"
        v-model="modelCloseAt"
        :placeholder="$t('insight.closeAt')"
        expanded
        editable
        :first-day-of-week="0"
      ></b-datepicker>
      <div
        v-if="!this.$store.state.insight.isLoading && $store.getters.open_at < new Date()"
        style="margin-top:5px;"
      >
        <b-switch
          style="vertical-align:middle;"
          v-model="closeMeeting"
          type="is-warning"
        /><span style="margin-left:-10px;font-size:12px;">{{
          $t("insight.close")
        }}</span>
      </div>
      
    <div class="field">
      <label class="label">{{ $t("insight.nbVotes") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.insight.isLoading }"
      >
        <label class="radio">
          <input
            type="radio"
            value="1"
            name="RETOUR_INSIGHT"
            v-bind:checked="isChecked_RETOUR_INSIGHT_OUI"
            @click="onFormChange"
            v-bind="{ disabled: this.$store.state.insight.isLoading }"
          />
          {{ $t("insight.unVote") }}
        </label>
        <br />
        <label class="radio">
          <input
            type="radio"
            value="0"
            name="RETOUR_INSIGHT"
            v-bind:checked="isChecked_RETOUR_INSIGHT_NON"
            @click="onFormChange"
            v-bind="{ disabled: this.$store.state.insight.isLoading }"
          />
          {{ $t("insight.plusieursVotes") }}
        </label>
        <br />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("insight.background") }}</label>
      <div
        class="input"
        style="display:flex"
        v-if="!this.$store.state.insight.admin_has_background && !this.file"
      >
        <b-upload
          style="margin-left:-8px;"
          accept="image/png, image/gif, image/jpeg, video/mp4"
          v-model="file"
          @input="checkFileSize()"
        >
          <p class="file-label">
            <img
              style="margin-left:5px;margin-right:10px;width:18px; height:18px;"
              src="~@/assets/img/icons/add_photo.png"
              alt="add-photo"
            /><span>{{ $t("insight.file") }}</span>
          </p>
        </b-upload>
      </div>
      <div
        style="font-size:12px"
        v-if="this.$store.state.insight.admin_has_background || this.file"
      >
        <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
        {{ $t("insight.file_ok") }}
        <span class="is-pulled-right" @click="removeFile">
          <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
        </span>
      </div>

      <img
        style="width:250px"
        v-if="this.$store.state.insight.admin_has_background"
        :src="this.url_insight + this.$store.state.insight.admin_has_background"
      />
    </div>

    <!-- thanks field fr -->
        <div class="field">
          <label class="label">{{ $t("insight.thanks") }}</label>
          <div>
            <img
              style="height:25px;width:25px;margin-bottom:-6px;"
              src="~@/assets/img/france.png"
              alt="flag-fr"
            />
            <span
              style="font-weight:lighter"
              class="smallTextThanks"
            >{{ $t("insight.thanks.dessous") }}</span>
          </div>
          <div class="control" v-bind:class="{'is-loading':this.$store.state.insight.isLoading}">
            <textarea
              :value="insight_thanks_fr"
              name="THANKS_FR"
              @input="onFormChange"
              type="textarea"
              class="textarea"
              maxlength="200"
              rows="1"
              :placeholder="$t('insight.placeholder.thanks-fr')"
              v-bind="{'disabled':this.$store.state.insight.isLoading}"
            ></textarea>
          </div>
        </div>

        <!-- thanks field en -->
        <div class="field">
          <div>
            <img
              style="width:25px;;margin-bottom:-6px;"
              src="~@/assets/img/united-kingdom.png"
              alt="flag-fr"
            />
            <span
              style="font-weight:lighter"
              class="smallTextThanks"
            >{{ $t("insight.thanks.dessous") }}</span>
          </div>
          <div class="control" v-bind:class="{'is-loading':this.$store.state.insight.isLoading}">
            <textarea
              :value="insight_thanks_en"
              name="THANKS_EN"
              @input="onFormChange"
              type="textarea"
              class="textarea"
              maxlength="200"
              rows="1"
              :placeholder="$t('insight.placeholder.thanks-en')"
              v-bind="{'disabled':this.$store.state.insight.isLoading}"
            ></textarea>
          </div>
          <div class="mt-1 has-text-right">
          <button
            :disabled="!loading ? false : true"
            class="button"
            @click="SubmitForm()"
          >
            {{ $t("button.sauvegarder") }}
          </button>
        </div>
      </div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Parameters",
  data() {
    return {
      file: null,
      url_insight: process.env.VUE_APP_URL_MEDIA,
      query: "",
      shares: [],
      selectedCountryFr: true,
      selectedCountryEn: false,
      selectedCountryEs: false,
      selectedCountryDe: false,
      showWarningTranslation: false,
      loading: false
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let message = {
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  watch: {
    insights_affiche() {
      this.loading = false;
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: true,
        parameters: false
      });
    }
  },
  computed: {
    ...mapGetters([
      "insights_affiche",
      "insight_name",
      "insight_id",
      "insight_evenement",
      "insight_client",
      "insight_shares",
      "insight_state",
      "insight_thanks_en_fr",
      "insight_thanks_fr",
      "insight_thanks_en",
    ]),
    modelOpenAt: {
      get: function () {
        return this.$store.getters.open_at !== null
          ? this.$store.getters.open_at
          : null
      },
      set: function (newValue) {
        this.$store.commit('SET_OPEN_AT', newValue)
      }
    },
    modelCloseAt: {
      get: function () {
        return this.$store.getters.close_at !== null
          ? this.$store.getters.close_at
          : null
      },
      set: function (newValue) {
        this.$store.commit("SET_CLOSE_INSIGHT", 0);
        this.$store.commit('SET_CLOSE_AT', newValue)
      }
    },
    closeMeeting: {
      get: function () {
        if (this.$store.getters.getCloseMeeting === 1) return true
        else return false
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.commit("SET_CLOSE_INSIGHT", 1);
          this.$store.commit("SET_CLOSE_AT", new Date());
        }
        else {
          this.$store.commit("SET_CLOSE_INSIGHT",0);
          this.$store.commit("SET_CLOSE_AT", null);
        }

      }
    },
    insight_shares_tag: {
      get: function() {
        var shares = [];
        shares = this.$store.state.insight.fields.shares.split(";");
        shares.pop();
        return shares;
      },
      set: function() {}
    },
    showResultsClient: {
      get: function() {
        if (this.$store.getters.showResultsClient === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SHOW_RESULTS_CLIENT", 1);
        } else {
          this.$store.commit("SHOW_RESULTS_CLIENT", 0);
        }
      }
    },
    test_insight_thanks_fr() {
      if (this.insight_thanks_en_fr) {
        const thanks_fr = this.insight_thanks_en_fr.split("¤");
        this.$store.commit("UPDATE_INSIGHT_THANKS_FR", thanks_fr[0]);
      }
    },
    test_insight_thanks_en() {
      if (this.insight_thanks_en_fr) {
        const thanks_en = this.insight_thanks_en_fr.split("¤");
        this.$store.commit("UPDATE_INSIGHT_THANKS_EN", thanks_en[1]);
      }
    },
    isChecked_RETOUR_INSIGHT_NON() {
      if (this.$store.state.insight.fields.retour_insight == 0) return true;
      else return false;
    },
    isChecked_RETOUR_INSIGHT_OUI() {
      if (this.$store.state.insight.fields.retour_insight == 1) return true;
      else return false;
    },
    isChecked_STATE() {
      if (this.$store.state.insight.fields.state == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    let message = {
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  methods: {
    checkFileSize() {
      if (this.file && this.file.size > 6000000) {
        this.file = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.fichier_trop_lourd")
        });
      }
    },
    removeFile() {
      this.$store.commit(`ADMIN_HAS_BACKGROUND`, null);
      this.file = null;
    },
    SubmitForm(evt) {
      this.loading = true;
      if (this.$store.state.insight.isEditing) {
        this.$store.dispatch("update_insight", this.file);
      } else {
        this.$store.dispatch("create_new_insight", this.file);
      }
      this.file = null;
    },
    onFormChange(evt) {
      this.$store.commit(`UPDATE_INSIGHT_${evt.target.name}`, evt.target.value);
    }
  }
};
</script>
<style scoped>
.button {
  background: #424a60 !important;
  color: white;
  border-radius: 0px;
  font-size: 12px;
  margin: 5px;
}
.button:hover {
  background: #424a60 !important;
  color: white;
  border-radius: 0px;
  font-size: 12px;
  margin: 5px;
}
.button:focus {
  background: #424a60 !important;
  color: white;
  border-radius: 0px;
  font-size: 12px;
  margin: 5px;
}
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
.input:invalid {
  border: red solid 1px;
}
label {
  font-size: 12px;
}
.flag {
  opacity: 0.2;
  cursor: pointer;
}
.selected-flag {
  opacity: 1;
  cursor: pointer;
}
.button {
  color: white;
  border-radius: 4px;
  font-size: 12px;
}
.column {
  padding-bottom: 0px !important;
}
.textarea {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.textarea::placeholder {
  color: grey;
}
.p-1 {
  padding: 10px;
}
.hr-grey {
  height: 1px;
  width: 100%;
  background: grey;
}
.texte_petit {
  font-size: 9px;
}
.icon-flag {
  vertical-align: middle;
  min-height: 15px;
  min-width: 20px;
  margin-right: 8px;
  cursor: pointer;
}
</style>
